import { render } from "./TwoFactorAuthorization.vue?vue&type=template&id=19a7f7b6&ts=true"
import script from "./TwoFactorAuthorization.vue?vue&type=script&lang=ts"
export * from "./TwoFactorAuthorization.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__